/*
 * kareo-ui-tour
 * https://bitbucket.org/kareo/ui-tour

 * Version: 0.0.19 - 2016-05-06
 * License: private
 */
angular.module("kareo.ui.tour", ["kareo.ui.tour.templates", "kareo.ui.tour.guided"]);
angular.module('kareo.ui.tour.templates', ['templates/guided/docs/index.html', 'templates/guided/docs/notes1.html', 'templates/guided/docs/notes2.html', 'templates/guided/tour-end.html', 'templates/guided/tour-start.html', 'templates/guided/tour-step-button-row.html', 'templates/guided/tour-step.html', 'templates/guided/tour.html']);

angular.module("templates/guided/docs/index.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/docs/index.html",
    "<html lang=\"en\"><head><meta charset=\"UTF-8\"/><link href=\"tour.css\" rel=\"stylesheet\" type=\"text/css\"/><link href=\"core.css\" rel=\"stylesheet\" type=\"text/css\"/><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.2.20/angular.min.js\"></script><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.2.20/angular-sanitize.js\"></script><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.2.20/angular-cookies.js\"></script><script src=\"ui-tour.js\"></script></head><body ng-app=\"kareo.ui.tour\"><tour tour-name=\"notes\" tour-finish-callback=\"tourDone\" tour-start-callback=\"tourStart\"></tour></body></html>");
}]);

angular.module("templates/guided/docs/notes1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/docs/notes1.html",
    "<div>This is a tour description. Check out notes!</div><br/><br/><br/><div id=\"target1\" class=\"target\">target1</div><br/><br/><br/><div id=\"target2\" class=\"target\">target2</div><br/><br/><br/><div id=\"target3\" class=\"target\">target3</div><br/><br/><br/><div id=\"target4\" class=\"target\">target4</div><br/><br/><br/><div id=\"target5\" class=\"target\">target5</div><br/><br/><br/>");
}]);

angular.module("templates/guided/docs/notes2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/docs/notes2.html",
    "<br/><br/><br/><div id=\"target1\" class=\"target\">target1</div><br/><br/><br/><div id=\"target2\" class=\"target\">target2</div><br/><br/><br/><div id=\"target3\" class=\"target\">target3</div><br/><br/><br/><div id=\"target4\" class=\"target\">target4</div><br/><br/><br/><div id=\"target5\" class=\"target\">target5</div><br/><br/><br/>");
}]);

angular.module("templates/guided/tour-end.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/tour-end.html",
    "<div class=\"tour-card tour-end\"><div class=\"lightbox open\"><div class=\"modal\"><div class=\"card centered\"><div class=\"card-header\"><h2 ng-bind-html=\"config.title\"></h2></div><div class=\"panel success full-bleed nm\"><span class=\"text-has-icon\"><i class=\"ki check-alt\">You've finished the {{config.title}}</i></span></div><div class=\"card-content\"><div ng-bind-html=\"config.content\" class=\"mbl\">Your tour is over. Go outside and play!</div><button ng-click=\"endTour()\" ng-bind-html=\"config.endLabel\" class=\"button primary\">Finish Tour</button></div></div></div></div></div>");
}]);

angular.module("templates/guided/tour-start.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/tour-start.html",
    "<div class=\"tour-card tour-start\"><div class=\"lightbox open\"><div class=\"modal\"><div class=\"card centered\"><div ng-hide=\"showLoading\" class=\"card-header\"><h2>Welcome to Kareo Clinical</h2></div><div ng-hide=\"showLoading\" class=\"card-content\"><div ng-bind-html=\"config.content\">This is a tour description. Check out notes!</div><button ng-click=\"startTour()\" ng-bind-html=\"config.startLabel\" class=\"button primary\">Take the Notes Tour</button><button ng-click=\"abandonTour()\" class=\"button subtle buttonlink\">No Thanks</button></div><div ng-show=\"showLoading\" class=\"loading big-load\"><div class=\"loading-content\"><div class=\"spinner primary big\"></div><div class=\"loading-message\">Loading Your Tour...</div></div></div></div></div></div></div>");
}]);

angular.module("templates/guided/tour-step-button-row.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/tour-step-button-row.html",
    "<div class=\"tourStepButtons\"><button ng-click=\"actions.nextStep()\" class=\"button primary\">Next</button><button ng-click=\"actions.previousStep()\" ng-hide=\"hideBackButton()\" class=\"button subtle buttonlink\">Back</button></div>");
}]);

angular.module("templates/guided/tour-step.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/tour-step.html",
    "<div class=\"tour-card tour-step\"><iframe ng-src=\"{{activeStep().targetPage}}\" class=\"tourContent\"></iframe><div class=\"lightbox open\"><div class=\"modal\"><div ng-style=\"dialogPosition\" ng-class=\"activeStep().targetPointingDirection\" class=\"card\"><div class=\"card-content\"><div ng-bind-html=\"activeStep().content\" class=\"mbm\"></div><button-row></button-row></div></div></div></div></div>");
}]);

angular.module("templates/guided/tour.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("templates/guided/tour.html",
    "<div ng-hide=\"stepControl.tourDone\" class=\"tour\"><div ng-show=\"stepControl.activeStep &gt;= 0\" class=\"tourBar\"><div class=\"notes-tour-header\"><img src=\"/common-ui/image/kareo_logo_orange_kman.png\"/><h2 ng-bind-html=\"tourTitle\"></h2><button ng-click=\"endTourAction()\" class=\"small button endTourButton\">End tour</button></div></div><tour-start step-control=\"stepControl\" callback=\"tourStartCallback\" config=\"tourStartConfig\" ng-hide=\"stepControl.activeStep &gt;= 0\">Tour Start</tour-start><div ng-show=\"stepControl.activeStep &gt;= 0 &amp;&amp; stepControl.activeStep &lt; tourSteps.length\"><tour-step step-control=\"stepControl\"></tour-step></div><tour-end end-tour-action=\"endTourAction\" callback=\"tourEndCallback\" config=\"tourEndConfig\" ng-show=\"stepControl.activeStep &gt;= tourSteps.length\">Tour Done</tour-end></div>");
}]);

(function() {
  angular.module("kareo.ui.tour.guided", ["ngSanitize", "kareo.ui.shared.modules.data", "kareo.ui.shared.directives.analytics"]).factory("tourService", [
    function() {
      var getTour, tours;
      tours = {
        "notes": {
          title: 'Kareo Notes Tour',
          stepConfiguration: [
            {
              content: "<strong>Kareo Clinical was made to help doctors write notes quickly and effectively</strong>. Let's take a look.",
              hideBackButton: true,
              targetElement: "div.step-signed .drug-sig-line",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: ""
            }, {
              content: "Here is our patient for this tour. Christy Generalmed Demo, aged 43.",
              targetElement: "div.step-signed span.age",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: "top-left"
            }, {
              content: "You can <strong>see any previous notes</strong> for this patient here.",
              targetElement: "div.step-signed .clinical_notes_header",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: "top-left"
            }, {
              content: "This <strong>window moves around</strong> so you can compare clinical note information.",
              targetElement: ".default-off.step-previous-note.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.epocrates.ui-draggable.ui-resizable .ui-widget-header",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-previous-note",
              targetPointingDirection: "bottom-center"
            }, {
              content: "When you're done, you close the window here.",
              targetElement: ".default-off.step-previous-note.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.epocrates.ui-draggable.ui-resizable .ui-widget-header",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-previous-note",
              targetPointingDirection: "bottom-right"
            }, {
              content: "The note will default to a <strong>SOAP</strong> Note, but you can change it an <strong>H&ampP</strong>, a <strong>PsychEval</strong>, or <strong>several other note types</strong>.",
              targetElement: ".step-signed #note_switcher",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: "top-left"
            }, {
              content: "To speed up routine visits or repeat patients, you can use the <strong>SALT (Same as Last Time)</strong> button to copy the previous note for that patient.",
              targetElement: ".step-signed #saltNote",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: "top-left"
            }, {
              content: "Let's select a previous note to <strong>quickly populate the note.</strong>",
              targetElement: ".step-signed #saltNote",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: "top-left"
            }, {
              content: "The SALT feature <strong>saves you time</strong> by filling in the note with data from a previously selected visit.  You can then adjust the data as needed.",
              targetElement: ".step-data #cc",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-data",
              targetPointingDirection: "bottom-center"
            }, {
              content: "<strong>Clicking on a section</strong> of the note allows you to enter data in that section.",
              targetElement: ".step-data .HPI",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-data&step-edit-subjective",
              targetPointingDirection: "top-left"
            }, {
              content: "You can choose to write your note with <strong>free form text</strong>, or use our <strong>powerful templates</strong> to quickly construct the note.",
              targetElement: ".step-data .template-actions",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-data&step-edit-subjective",
              targetPointingDirection: "right-center"
            }, {
              content: "Kareo contains a <strong>variety of templates</strong> that suit your specialty.  You can also create <strong>custom templates</strong> for your specific practice.",
              targetElement: ".x-menu-list-item.x-menu-item-active",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-data&step-template1",
              targetPointingDirection: "top-left"
            }, {
              content: "Kareo Clinical already contains <strong>pre-built templates for dozens of specialties</strong>, including General Practice, Mental Health, Cardiology, and others.",
              targetElement: "#ext-comp-3295",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-data&step-template2",
              targetPointingDirection: "right-center"
            }, {
              content: "When you're done, you can <strong>sign</strong> the note, <strong>create a superbill</strong>, or <strong>send a referral</strong>.",
              targetElement: ".step-signed #new-superbill-link",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#",
              targetPointingDirection: "bottom-center"
            }, {
              content: "Here is the finished note.",
              targetElement: ".default-off.step-signed.main-note-panel.view-only .ALLERGY",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-signed",
              targetPointingDirection: ""
            }, {
              content: "The bottom toolbar lets you copy, create a superbill, send referral, or add an addendum to the note.",
              targetElement: ".view-only #go-to-copy-note",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-signed",
              targetPointingDirection: "bottom-left"
            }, {
              content: "When you're done, you can save here.",
              targetElement: ".view-only .ehr-note-footer-save",
              targetPage: "/common-ui/static-pages/notes_tour_1.html#step-signed",
              targetPointingDirection: "bottom-right"
            }
          ],
          endDialogConfiguration: {
            content: "<p class='nm large-text'>You're on your way to making your practice a best practice with Kareo Clinical.</p><ul><li><a href='http://www.kareo.com/help/ehr/webinars' target='_blank'>Sign up for a free, live webinar on how to get started quickly with Kareo Clinical</a></li></ul>",
            endLabel: "Finish Tour",
            title: 'Notes Tour'
          },
          startDialogConfiguration: {
            content: "<p class='nm large-text'>Thanks for trying out Kareo Clinical. We want you to be successful using Kareo Clinical when creating notes and taking care of your patients.</p><p class='mbl'>Get to know how to use Kareo Clinical by creating a demo patient note.</p>",
            startLabel: 'Take the Notes Tour'
          }
        },
        test: {
          title: 'Kareo Notes Tour',
          stepConfiguration: [
            {
              content: "Point top-left!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "top-left"
            }, {
              content: "Point top-center!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "top-center"
            }, {
              content: "Point top-right!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "top-right"
            }, {
              content: "Point right-top!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "right-top"
            }, {
              content: "Point right-center!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "right-center"
            }, {
              content: "Point right-bottom!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "right-bottom"
            }, {
              content: "Point bottom-right!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "bottom-right"
            }, {
              content: "Point bottom-center!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "bottom-center"
            }, {
              content: "Point bottom-left!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "bottom-left"
            }, {
              content: "Point left-bottom!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "left-bottom"
            }, {
              content: "Point left-center!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "left-center"
            }, {
              content: "Point left-top!",
              targetElement: "#uniform-note_switcher",
              targetPage: "http://localhost:3002/dashboard-calendar-ui/demo.html",
              targetPointingDirection: "left-top"
            }
          ],
          endDialogConfiguration: {
            content: "<p>You're on your way to making your practice a best practice with Kareo Clinical.</p>",
            endLabel: "<i class=\"ki goback\"></i> Go back to Dashboard",
            title: 'Notes Tour'
          },
          startDialogConfiguration: {
            content: "<p>Thanks for trying out the Kareo Clinical. We want you to be successful using the Kareo Clinical when creating notes and taking care of your patients.</p><p>Get to know how to use the Kareo Clinical by creating a demo patient note.</p>",
            startLabel: 'Take the Notes Tour'
          }
        },
        "directive-demo": {
          title: 'Directive Demo',
          stepConfiguration: [
            {
              content: "<strong>Demo</strong>. Let's take a look.",
              targetElement: "#getting_started",
              targetPage: "http://localhost:3002/shared-directives/index.html"
            }
          ],
          endDialogConfiguration: {
            content: "<p>You're on your way to making your practice a best practice with Kareo Clinical.</p>",
            endLabel: "<i class=\"ki goback\"></i> Go back to Dashboard",
            title: 'Directive Tour'
          },
          startDialogConfiguration: {
            content: "<p>Thanks for trying out the Kareo Clinical. We want you to be successful using the Kareo Clinical when creating notes and taking care of your patients.</p><p>Get to know how to use the Kareo Clinical by creating a demo patient note.</p>",
            startLabel: 'Take the Directive Tour'
          }
        }
      };
      getTour = function(tourName) {
        return tours[tourName];
      };
      return {
        tour: function(tourName) {
          return getTour(tourName);
        }
      };
    }
  ]).controller("TourController", [
    "$scope", "tourService", function($scope, tourService) {
      $scope.tourSteps = tourService.tour($scope.tourName).stepConfiguration;
      $scope.tourTitle = tourService.tour($scope.tourName).title;
      $scope.tourStartConfig = tourService.tour($scope.tourName).startDialogConfiguration;
      $scope.tourEndConfig = tourService.tour($scope.tourName).endDialogConfiguration;
      $scope.stepControl = {
        activeStep: -1,
        tourSteps: $scope.tourSteps,
        tourDone: false,
        incrementStep: function() {
          $scope.stepControl.activeStep++;
        },
        decrementStep: function() {
          $scope.stepControl.activeStep--;
        },
        cancelTour: function() {
          $scope.endTourAction();
        }
      };
      return $scope.endTourAction = function() {
        $scope.stepControl.tourDone = true;
        if ($scope.tourFinishCallback instanceof Function) {
          $scope.tourFinishCallback();
        }
      };
    }
  ]).controller("TourStartController", [
    "$scope", "authenticatedUser", "$timeout", function($scope, authenticatedUser, $timeout) {
      $scope.showLoading = false;
      $scope.abandonTour = function() {
        return $scope.stepControl.cancelTour();
      };
      return $scope.startTour = function() {
        $scope.showLoading = true;
        $timeout((function() {
          authenticatedUser.updateTourStatus(0, 1);
          $scope.stepControl.incrementStep();
          if ($scope.callback instanceof Function) {
            return $scope.callback();
          }
        }), 3000);
      };
    }
  ]).controller("TourEndController", [
    "$scope", "authenticatedUser", function($scope, authenticatedUser) {
      return $scope.endTour = function() {
        authenticatedUser.updateTourStatus(0, 2);
        if ($scope.callback instanceof Function) {
          $scope.callback();
        }
        $scope.endTourAction();
      };
    }
  ]).controller("TourStepController", [
    "$scope", "$interval", '$timeout', function($scope, $interval, $timeout) {
      $scope.actions = {
        nextStep: function() {
          $scope.stepControl.incrementStep();
        },
        previousStep: function() {
          $scope.stepControl.decrementStep();
        },
        cancelTour: function() {
          $scope.stepControl.cancelTour();
        }
      };
      $scope.dialogPosition = {
        top: "-999px",
        left: "-999px"
      };
      $scope.relocate = function() {
        var dialogRect, pointerOffset, target, targetRect, topOffset, xOffset, yOffset;
        if ($scope.frame && $scope.frame.contentDocument && $scope.activeStep()) {
          topOffset = 50;
          target = $scope.frame.contentDocument.querySelector($scope.activeStep().targetElement);
          if (target) {
            target.scrollIntoView(false);
            targetRect = target.getBoundingClientRect();
            if (targetRect.width > 0) {
              dialogRect = $scope.dialogElement.querySelector('.card').getBoundingClientRect();
              pointerOffset = 10;
              switch ($scope.activeStep().targetPointingDirection) {
                case 'bottom-left':
                  xOffset = targetRect.left;
                  yOffset = topOffset + targetRect.top - dialogRect.height - pointerOffset;
                  break;
                case 'bottom-center':
                  xOffset = targetRect.left + Math.floor(targetRect.width / 2) - Math.floor(dialogRect.width / 2);
                  yOffset = topOffset + targetRect.top - dialogRect.height - pointerOffset;
                  break;
                case 'bottom-right':
                  xOffset = targetRect.right - dialogRect.width;
                  yOffset = topOffset + targetRect.top - dialogRect.height - pointerOffset;
                  break;
                case 'right-top':
                  xOffset = targetRect.left - dialogRect.width - pointerOffset;
                  yOffset = topOffset + targetRect.top;
                  break;
                case 'right-center':
                  xOffset = targetRect.left - dialogRect.width - pointerOffset;
                  yOffset = topOffset + targetRect.top + Math.floor(targetRect.height / 2) - Math.floor(dialogRect.height / 2);
                  break;
                case 'right-bottom':
                  xOffset = targetRect.left - dialogRect.width - pointerOffset;
                  yOffset = topOffset + targetRect.bottom - dialogRect.height;
                  break;
                case 'left-top':
                  xOffset = targetRect.right + pointerOffset;
                  yOffset = topOffset + targetRect.top;
                  break;
                case 'left-center':
                  xOffset = targetRect.right + pointerOffset;
                  yOffset = topOffset + targetRect.top + Math.floor(targetRect.height / 2) - Math.floor(dialogRect.height / 2);
                  break;
                case 'left-bottom':
                  xOffset = targetRect.right + pointerOffset;
                  yOffset = topOffset + targetRect.bottom - dialogRect.height;
                  break;
                case 'top-left':
                  xOffset = targetRect.left;
                  yOffset = topOffset + targetRect.bottom + pointerOffset;
                  break;
                case 'top-center':
                  xOffset = targetRect.left + Math.floor(targetRect.width / 2) - Math.floor(dialogRect.width / 2);
                  yOffset = topOffset + targetRect.bottom + pointerOffset;
                  break;
                case 'top-right':
                  xOffset = targetRect.right - dialogRect.width;
                  yOffset = topOffset + targetRect.bottom + pointerOffset;
                  break;
                default:
                  xOffset = Math.floor((document.body.getBoundingClientRect().width - dialogRect.width) / 2);
                  yOffset = 300;
              }
              $scope.dialogPosition.top = yOffset + "px";
              $scope.dialogPosition.left = xOffset + "px";
            }
          }
        }
      };
      $scope.$watch(function() {
        return $scope.stepControl.activeStep;
      }, function() {
        return $timeout(function() {
          return $scope.relocate();
        }, 0);
      });
      $scope.relocate();
      return $interval($scope.relocate, 1000);
    }
  ]).controller("TourButtonController", ["$scope", function($scope) {}]).directive("tour", function() {
    return {
      restrict: "E",
      transclude: true,
      replace: true,
      scope: {
        tourName: "@",
        tourFinishCallback: '=',
        tourStartCallback: '='
      },
      templateUrl: "templates/guided/tour.html",
      controller: "TourController"
    };
  }).directive("tourStart", function() {
    return {
      restrict: "E",
      transclude: true,
      replace: true,
      scope: {
        stepControl: "=",
        config: "=",
        callback: "="
      },
      templateUrl: "templates/guided/tour-start.html",
      controller: "TourStartController"
    };
  }).directive("tourEnd", function() {
    return {
      restrict: "E",
      transclude: true,
      replace: true,
      scope: {
        endTourAction: "=",
        config: "=",
        callback: "="
      },
      templateUrl: "templates/guided/tour-end.html",
      controller: "TourEndController"
    };
  }).directive("tourStep", function() {
    return {
      restrict: "E",
      replace: true,
      scope: {
        stepControl: "="
      },
      link: function(scope, element, attr) {
        scope.dialogElement = element[0];
        scope.frame = element.find('iframe')[0];
        scope.activeStep = function() {
          return scope.stepControl.tourSteps[scope.stepControl.activeStep];
        };
        return scope.hideBackButton = function() {
          if (!scope.activeStep()) {
            return false;
          }
          return scope.activeStep().hideBackButton || scope.stepControl.activeStep === 0;
        };
      },
      templateUrl: "templates/guided/tour-step.html",
      controller: "TourStepController"
    };
  }).directive("buttonRow", function() {
    return {
      restrict: "E",
      replace: true,
      transclude: true,
      templateUrl: "templates/guided/tour-step-button-row.html",
      controller: "TourButtonController"
    };
  });

}).call(this);
